export const CAMPUS_PROGRAM_OPTIONS = [
  "Pre-Medical (FSc)",
  "Pre-Engineering (FSc)",
  "Computer Science (ICS)",
  "Commerce (ICom)",
  "Arts (FA)",
];

/** Old labels / Excel column names → current program name */
export const CAMPUS_PROGRAM_LEGACY_ALIASES = {
  "Pre-Medical": "Pre-Medical (FSc)",
  "Pre-Engineering": "Pre-Engineering (FSc)",
  ICS: "Computer Science (ICS)",
  Commerce: "Commerce (ICom)",
  Arts: "Arts (FA)",
};

/** Excel column header for each program (includes legacy headers for old templates) */
export const CAMPUS_PROGRAM_EXCEL_LOOKUP = CAMPUS_PROGRAM_OPTIONS.map((name) => ({
  name,
  columns: [
    name,
    ...Object.entries(CAMPUS_PROGRAM_LEGACY_ALIASES)
      .filter(([, v]) => v === name)
      .map(([k]) => k),
  ],
}));

export function normalizeCampusProgramName(name) {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "";
  return CAMPUS_PROGRAM_LEGACY_ALIASES[trimmed] || trimmed;
}

export function parseCampusProgramsFromExcelRow(getVal, row) {
  const programs = [];

  CAMPUS_PROGRAM_EXCEL_LOOKUP.forEach(({ name, columns }) => {
    for (const col of columns) {
      const val = getVal(row, col);
      if (val && val.toString().toLowerCase().trim() === "yes") {
        if (!programs.includes(name)) programs.push(name);
        break;
      }
    }
  });

  const othersVal = getVal(row, "Others");
  if (othersVal && othersVal.toString().trim() !== "") {
    const othersText = othersVal.toString().trim();
    if (!["-", "n/a", "yes", "no"].includes(othersText.toLowerCase())) {
      programs.push(othersText);
    }
  }

  return programs;
}
